import axios from 'axios';

// Dynamically get token from localStorage
const token = localStorage.getItem('token');


const COMMON_HEADERS = {
  'Content-Type': 'application/json',
  ...(token && { 'Authorization': `Bearer ${token}` }),
}





/**
 * In CRA development, use same-origin /api/* paths so requests go through setupProxy.js.
 * Hardcoding http://localhost:5004 breaks when the UI is opened via LAN IP (browser would call
 * the wrong machine and axios reports "Network Error").
 *
 * Override any base with REACT_APP_*_URL when needed (e.g. production split domains).
 */

// Base URLs for each microservice of server

// const BASE_URL_GLOBAL     = 'http://localhost:5001/api/global';
// const BASE_URL_COMPLIANCE = 'http://localhost:5002/api/compliance';
// const BASE_URL_AUDIT      = 'http://localhost:5005/api/audit';
// const BASE_URL_REGISTER   = 'http://localhost:5004/api/register';


// Base URLs for each microservice of server
const BASE_URL_GLOBAL     = 'https://global.accunityhr.in/api/global';
const BASE_URL_COMPLIANCE = 'https://compliance.accunityhr.in/api/compliance';
const BASE_URL_AUDIT      = 'https://audit.accunityhr.in/api/audit';
const BASE_URL_REGISTER   = 'https://register.accunityhr.in/api/register';

// Base URLs for each microservice of remote local pc
// const BASE_URL_GLOBAL     = 'http://192.168.0.5:5001/api/global';
// const BASE_URL_COMPLIANCE = 'http://192.168.0.5:5002/api/compliance';
// const BASE_URL_AUDIT      = 'http://192.168.0.5:5005/api/audit';
// const BASE_URL_REGISTER   = 'http://192.168.0.5:5004/api/register';

// Base URLs for each microservice of testing instance
// const BASE_URL_GLOBAL     = 'https://test.global.accunityhr.in/api/global';
// const BASE_URL_AUDIT      = 'https://test.audit.accunityhr.in/api/audit';
// const BASE_URL_COMPLIANCE = 'https://test.compliance.accunityhr.in/api/compliance';
// const BASE_URL_REGISTER   = 'https://test.register.accunityhr.in/api/register';

export const complianceApi = axios.create({
  baseURL: BASE_URL_COMPLIANCE,
  headers: COMMON_HEADERS,
});

export const registerApi = axios.create({
  baseURL: BASE_URL_REGISTER,
  headers: COMMON_HEADERS,
});

export const auditApi = axios.create({
    baseURL: BASE_URL_AUDIT,
    headers: COMMON_HEADERS,
  });

export const globalApi = axios.create({
  baseURL: BASE_URL_GLOBAL,
  headers: COMMON_HEADERS,
});

function attachAuthInterceptor(instance) {
  instance.interceptors.request.use((config) => {
    const t = sessionStorage.getItem('token') || localStorage.getItem('token');
    if (t) {
      config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
  });
}

attachAuthInterceptor(complianceApi);
attachAuthInterceptor(registerApi);
attachAuthInterceptor(auditApi);
attachAuthInterceptor(globalApi);



// // axiosInstance.js
// import axios from 'axios';

// const BASE_URLS = {
//   global:     'http://localhost:5001/api/global',
//   compliance: 'http://localhost:5002/api/compliance',
//   audit:      'http://localhost:5005/api/audit',
//   register:   'http://localhost:5004/api/register',
// };

// const createApiInstance = (baseURL) => {
//   const instance = axios.create({ baseURL });

//   // Add request interceptor for dynamic token
//   instance.interceptors.request.use(
//     (config) => {
//       const token = localStorage.getItem('token');
//       if (token) config.headers.Authorization = `Bearer ${token}`;
//       config.headers['Content-Type'] = 'application/json';
//       return config;
//     },
//     (error) => Promise.reject(error)
//   );

//   return instance;
// };


// export const globalApi     = createApiInstance(BASE_URLS.global);
// export const complianceApi = createApiInstance(BASE_URLS.compliance);
// export const auditApi      = createApiInstance(BASE_URLS.audit);
// export const registerApi   = createApiInstance(BASE_URLS.register);
